import React, { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { BRAND, NAV_LINKS, BOOKING_URL } from "../mock";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-md bg-black/70 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="cga-container flex items-center justify-between py-4 px-2">
        <a href="#top" className="flex items-center gap-3 group">
          <div className="w-11 h-11 rounded-xl bg-white/95 p-1 flex items-center justify-center shadow-[0_4px_20px_-6px_rgba(94,234,212,0.35)] transition-transform group-hover:-translate-y-0.5">
            <img
              src={BRAND.logo}
              alt={BRAND.name}
              className="w-full h-full object-contain"
            />
          </div>
          <div className="leading-tight hidden sm:block">
            <div className="text-white font-bold tracking-tight text-[15px]">
              Coastal Growth
            </div>
            <div className="text-[10px] tracking-[0.22em] text-[#5eead4] uppercase">
              Advisors
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-sm text-white/80 hover:text-[#5eead4] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="cga-cta-primary text-sm py-2.5 px-4"
          >
            Book a Call <ArrowRight className="w-4 h-4" />
          </a>
        </nav>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="md:hidden w-10 h-10 inline-flex items-center justify-center rounded-lg border border-white/10 text-white"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/95 backdrop-blur-md">
          <div className="px-6 py-5 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-white/85 hover:text-[#5eead4]"
              >
                {l.label}
              </a>
            ))}
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="cga-cta-primary justify-center"
            >
              Book a Strategy Call <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
